export default __webpack_public_path__ + "27e4e1104ecd8342af2eeeed6a0bb09a.png";